// extracted by mini-css-extract-plugin
export default {"inputWrapper":"text-input-module--input-wrapper--a397c"};